const constants = {
  content: {
    horizontalAlignment: {
      left: '',
      center: 'u-textCenter',
      right: 'u-textRight',
    },
    getHorizontalAlignment(param) {
      return this.horizontalAlignment[param] || this.horizontalAlignment.left
    },
    verticalAlignment: {
      center: '',
    },
    textColors: ['white', 'black'],
    eyebrowFonts: ['Roboto', 'Publico'],
    secondaryHeadingColors: ['inherit', 'brand', 'neutral', 'white'],
  },
  textColors: {
    dark: 'u-textColorBrandDark',
    action: 'u-textColorAction',
    primary: 'u-textColorBrand',
    aqua: 'u-textColorAqua',
    yellow: 'u-textColorYellow',
    raspberry: 'u-textColorRaspberry',
    white: 'u-textColorWhite',
  },
  angleTypes: ['content', 'image', 'slant', 'straight'],
  backgroundColors: {
    white: 'u-bgColorWhite',
    brand: 'u-bgColorBrand',
    action: 'u-bgColorAction',
    dark: 'u-bgColorBrandDark',
    image: 'u-bgColorTransparent',
  },
  grid: {
    whole: '1',
    halves: '2',
    thirds: '3',
    fourths: '4',
  },
  getGridSize(params) {
    return this.grid[params] || this.grid.whole
  },
  width: {
    full: 'u-sizeFill',
    inset: 'u-sizeConstrained',
  },
  verticalMargin: {
    0: 'u-marginVert0gu',
    1: 'u-marginVert1gu',
    2: 'u-marginVert3gu',
    3: 'u-marginVert4gu',
    4: 'u-marginVert3gu',
  },
  horizontalCrop: {
    left: '',
    center: '',
    vertical: '',
  },
  verticalCrop: {
    left: '',
    center: '',
    vertical: '',
  },
}

export { constants }
